var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDrive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 40,
    viewBox: "0 0 44 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_108_1295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33021 34.242L5.27029 37.6481C5.67343 38.3653 6.25288 38.9288 6.9332 39.3386C8.88176 36.8243 10.2382 34.895 11.0024 33.5505C11.778 32.186 12.7312 30.0518 13.862 27.1478C10.8142 26.74 8.50468 26.5361 6.93337 26.5361C5.42518 26.5361 3.11552 26.74 0.00439453 27.1478C0.00439453 27.9417 0.205964 28.7356 0.609103 29.4528L3.33021 34.242Z",
    fill: "#0066DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0671 39.3386C37.7476 38.9288 38.3271 38.3653 38.73 37.6483L39.5363 36.2397L43.3914 29.4528C43.787 28.7512 43.9954 27.9566 43.9959 27.1478C40.8667 26.74 38.5613 26.5361 37.0798 26.5361C35.4876 26.5361 33.1821 26.74 30.1636 27.1478C31.281 30.0678 32.2217 32.202 32.9855 33.5505C33.7559 34.9109 35.1164 36.8403 37.0671 39.3386Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0001 12.8054C24.2546 10.0377 25.8084 7.90346 26.6613 6.40279C27.3482 5.19441 28.1041 3.26504 28.9289 0.614672C28.2486 0.204891 27.4676 0 26.6613 0H17.3389C16.5326 0 15.7518 0.230568 15.0713 0.614672C16.1207 3.65432 17.011 5.81758 17.7424 7.10445C18.5507 8.52664 19.97 10.427 22.0001 12.8054Z",
    fill: "#00832D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1384 27.1475H13.862L6.93335 39.3382C7.6135 39.748 8.39451 39.9529 9.20079 39.9529H34.7996C35.6059 39.9529 36.3871 39.7223 37.0672 39.338L30.1384 27.1475Z",
    fill: "#2684FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0002 12.8058L15.0716 0.615234C14.3911 1.02502 13.8116 1.58833 13.4085 2.30554L0.609103 24.843C0.213397 25.5447 0.00494124 26.3392 0.00439453 27.148H13.862L22.0002 12.8058Z",
    fill: "#00AC47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9917 13.5734L30.5918 2.30456C30.1888 1.58736 29.6092 1.02404 28.9289 0.614258L22.0002 12.805L30.1383 27.1472H43.9708C43.9708 26.3531 43.7692 25.5594 43.3661 24.8422L36.9917 13.5734Z",
    fill: "#FFBA00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_108_1295"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDrive);
export default __webpack_public_path__ + "static/media/ic_drive.b299b31b9cf85328936974ddb787af67.svg";
export { ForwardRef as ReactComponent };